import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';
// import type { ColorId } from './ColorId.d';


import { faCircle as faCircleSolid } from '@fortawesome/pro-solid-svg-icons';
import { COLOR_NAME, CSS_COLOR_CLASS } from '../constants';

export const getTranslatedColorButtonGroupOptions = ({
	phrases,
}: {
	phrases: Phrases;
}): {
	capsuleContainerColorOptions: ButtonGroupOption[];
	capsulePowderColorOptions: ButtonGroupOption[];
	crystalColorOptions: ButtonGroupOption[];
	liquidColorOptions: ButtonGroupOption[];
	pillColorOptions: ButtonGroupOption[];
	powderColorOptions: ButtonGroupOption[];
} => {
	const WHITE: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.WHITE],
		label: phrases['notificationForm.common.colorField.value.white'],
		value: COLOR_NAME.WHITE,
	} as const;

	const LIGHT_GRAY: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.LIGHT_GRAY],
		label: phrases['notificationForm.common.colorField.value.lightGray'],
		value: COLOR_NAME.LIGHT_GRAY,
	} as const;

	// const UNKNOWN: ButtonGroupOption = {
	// 	label: 'Vet ikke',
	// 	value: 'unknown',
	// } as const;

	const TRANSPARENT: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.TRANSPARENT],
		label: phrases['notificationForm.common.colorField.value.transparent'],
		value: COLOR_NAME.TRANSPARENT,
	} as const;

	const GRAY: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.GRAY],
		label: phrases['notificationForm.common.colorField.value.gray'],
		value: COLOR_NAME.GRAY,
	} as const;

	const BLACK: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.BLACK],
		label: phrases['notificationForm.common.colorField.value.black'],
		value: COLOR_NAME.BLACK,
	} as const;

	const LIGHT_BROWN: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.LIGHT_BROWN],
		label: phrases['notificationForm.common.colorField.value.lightBrown'],
		value: COLOR_NAME.LIGHT_BROWN,
	};

	const BROWN: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.BROWN],
		label: phrases['notificationForm.common.colorField.value.brown'],
		value: COLOR_NAME.BROWN,
	} as const;

	const RED: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.RED],
		label: phrases['notificationForm.common.colorField.value.red'],
		value: COLOR_NAME.RED,
	} as const;

	const ORANGE: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.ORANGE],
		label: phrases['notificationForm.common.colorField.value.orange'],
		value: COLOR_NAME.ORANGE,
	} as const;

	const YELLOW: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.YELLOW],
		label: phrases['notificationForm.common.colorField.value.yellow'],
		value: COLOR_NAME.YELLOW,
	} as const;

	const PALE_GOLDENROD: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.PALE_GOLDENROD],
		label: phrases['notificationForm.common.colorField.value.paleGoldenrod'],
		value: COLOR_NAME.PALE_GOLDENROD,
	} as const;

	const GOLD: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.GOLD],
		label: phrases['notificationForm.common.colorField.value.gold'],
		value: COLOR_NAME.GOLD,
	} as const;

	const GREEN: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.GREEN],
		label: phrases['notificationForm.common.colorField.value.green'],
		value: COLOR_NAME.GREEN,
	};

	const TURQUOISE: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.TURQUOISE],
		label: phrases['notificationForm.common.colorField.value.turquoise'],
		value: COLOR_NAME.TURQUOISE,
	} as const;

	const BLUE: ButtonGroupOption ={
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.BLUE],
		label: phrases['notificationForm.common.colorField.value.blue'],
		value: COLOR_NAME.BLUE,
	} as const;

	const PURPLE: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.PURPLE],
		label: phrases['notificationForm.common.colorField.value.purple'],
		value: COLOR_NAME.PURPLE,
	} as const;

	const PINK: ButtonGroupOption = {
		icon: faCircleSolid,
		iconColor: CSS_COLOR_CLASS[COLOR_NAME.PINK],
		label: phrases['notificationForm.common.colorField.value.pink'],
		value: COLOR_NAME.PINK,
	} as const;

	const OTHER: ButtonGroupOption = {
		label: phrases['notificationForm.common.colorField.value.other'],
		value: COLOR_NAME.OTHER,
	} as const;

	const pillColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		RED,
		YELLOW,
		BLUE,
		TURQUOISE,
		PINK,
		OTHER,
	] as const;

	const capsuleContainerColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		TRANSPARENT,
		RED,
		YELLOW,
		BLUE,
		TURQUOISE,
		PINK,
		OTHER,
	] as const;

	const capsulePowderColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		TURQUOISE,
		BLUE,
		PINK,
		OTHER,
	] as const;

	const crystalColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		TRANSPARENT,
		TURQUOISE,
		BLUE,
		PINK,
		GRAY,
		BLACK,
		LIGHT_BROWN,
		BROWN,
		OTHER,
	] as const;

	const powderColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		PALE_GOLDENROD,
		YELLOW,
		PINK,
		ORANGE,
		GRAY,
		BLACK,
		LIGHT_BROWN,
		BROWN,
		OTHER,
	] as const;

	const liquidColorOptions: ButtonGroupOption[] = [
		WHITE,
		LIGHT_GRAY,
		PALE_GOLDENROD,
		YELLOW,
		PINK,
		GRAY,
		BLACK,
		LIGHT_BROWN,
		BROWN,
		OTHER,
	] as const;

	return {
		capsuleContainerColorOptions,
		capsulePowderColorOptions,
		// colorId,
		crystalColorOptions,
		liquidColorOptions,
		pillColorOptions,
		powderColorOptions,
	} as const;
};
